export function initEducation(){
    const container = document.querySelector<HTMLElement>('.education-items');
    const items = container?.querySelectorAll<HTMLElement>('.education-item') ?? null;
    const button = document.querySelector<HTMLButtonElement>('.button-show-more');
    if (!container || !items || !button) return;

    // Если элементов ≤ 3 → скрываем кнопку
    if (items.length <= 3) {
        button.style.display = 'none';
        return;
    }

    // Скрываем все, кроме первых 3
    items.forEach((item, index) => {
        if (index > 2) {
            item.classList.add('is-hidden');
        }
    });

    // Обработчик клика на кнопку
    button.addEventListener('click', () => {
        items.forEach(item => item.classList.remove('is-hidden'));
        button.style.display = 'none';
    });
}